import React from 'react';
import { PROCESS } from '../mock';

const Process = () => (
  <section id="process" className="bg-app py-24 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <span className="text-xs tracking-[0.3em] text-sky-400 uppercase font-semibold">Process</span>
      <h2 className="mt-3 font-cond font-700 text-4xl md:text-5xl text-white">Repair in 4 Simple Steps</h2>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {PROCESS.map((p) => (
          <div key={p.n} className="group">
            <span className="font-display text-6xl text-white/10 group-hover:text-sky-500/30 transition-colors">{p.n}</span>
            <h3 className="mt-3 font-cond font-600 text-xl text-white">{p.title}</h3>
            <p className="mt-2 text-sm text-gray-400 leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
